import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { ActivatedRouteSnapshotWithGuardData, RoutesDefinition, RouteDefinition } from '../interface/auth.interface';
import { normalize } from '@/utils/normalizeString';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {

  constructor(
    private auth: AuthService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshotWithGuardData): boolean {
    if (!route.data) {
      console.log(`No requiredPrivilege setted for route ${route.url}`);
      return this.rejectActivate();
    }

    // Necesario para hacer a la funcion havePrivileges reutilizable
    const routeDefinition: RouteDefinition = { name: '', path: '', ...route.data };

    if (!this.havePrivileges(routeDefinition)) {
      return this.rejectActivate();
    }

    return true;
  }

  havePrivileges(routeDefinition: RouteDefinition) {
    if (!routeDefinition) {
      console.log('No requiredPrivilege setted');
      return false;
    }
    const { requiredPrivilege, requiredPrivilegesAnd, requiredPrivilegesOr } = routeDefinition;

    const privilegeKeyCount = Object.keys(routeDefinition).reduce((acc, key) => (normalize(key).includes(normalize('Privilege')) ? acc + 1 : acc), 0);

    if (privilegeKeyCount > 1) {
      console.log('No multipleRequiredPrivilege params. use one of: requiredPrivilege, requiredPrivilegeAnd, requiredPrivilegeOr');
      return false;
    }
    if (requiredPrivilege) {
      if (!this.auth.userHavePrivilege(requiredPrivilege)) {
        return false;
      }
    }
    if (requiredPrivilegesAnd) {
      const havePrivileges = requiredPrivilegesAnd.every((privilege) => this.auth.userHavePrivilege(privilege));
      if (!havePrivileges) {
        return false;
      }
    }
    if (requiredPrivilegesOr) {
      const havePrivileges = requiredPrivilegesOr.some((privilege) => this.auth.userHavePrivilege(privilege));
      if (!havePrivileges) {
        return false;
      }
    }

    return true;
  }

  private rejectActivate() {
    this.router.navigate(['/']); // redirect to dashboard
    return false;
  }

}
